export default "__VITE_ASSET__Dfn3FZbU__"